import React, { useState, useRef, useEffect } from "react";
import { Button, Modal, ListGroup, Badge, Form } from "react-bootstrap";
import { Elements, PaymentElement } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  brandLogos,
  capitalizeFirst,
  getMonthName,
  stripe_promise,
} from "../../constant/commonUtils";
import { useSelector } from "react-redux";
import { errorMessage, successMessage } from "../../Errors/Toast";
import commonApi from "../../CommonApi/CommonServices";

const stripePromise = loadStripe(stripe_promise());

const SavedCards = ({ savedData, handleCard, setSavedData }) => {
  const [showModal, setShowModal] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);
  const menuRef = useRef(null);
  const tokenSelector = useSelector((state) => state.rootReducer?.user?.token);

  const [cards, setCards] = useState([
    {
      id: "card_1",
      brand: "visa",
      last4: "4242",
      exp_month: "02",
      exp_year: "2099",
      default: true,
    },
    {
      id: "card_2",
      brand: "mastercard",
      last4: "4444",
      exp_month: "06",
      exp_year: "2029",
      default: false,
    },
  ]);

  const set_default_payment_method = (paymentId) => {
    const payload = {
      payment_method_id: paymentId,
    };
    commonApi
      .set_default_payment_method(payload, tokenSelector)
      .then((res) => {
        if (res.status === 200 && res.success) {
          successMessage(res.message);
          setSavedData((prev) =>
            prev.map((card) => ({
              ...card,
              is_default: card.id === paymentId,
            }))
          );
        } else {
          errorMessage(res.message);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };

  const handleSetDefault = (id) => {
    setCards((prev) =>
      prev.map((card) => ({
        ...card,
        default: card.id === id,
      }))
    );

    setOpenMenuId(null);
  };

  const handleDelete = (id) => {
    setCards((prev) => prev.filter((card) => card.id !== id));
    setOpenMenuId(null);
  };

  // Close menu when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the click is outside any card-options-menu, close the menu
      if (!event.target.closest(".card-options-menu")) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const new_ScrollBar = () => {
    const toggle_element = document.getElementById("toggle_drop");

    if (toggle_element) {
      setOpenMenuId(null);
    }
  };

  return (
    <div className="p-4 bg-white rounded shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Saved Cards</h5>
        <Button
          className="submit_button"
          variant="primary"
          onClick={() => {
            handleCard("add_card");
          }}
        >
          Add Card
        </Button>
      </div>

      <ListGroup
        style={{
          maxHeight: savedData?.length > 2 ? "300px" : "unset",
          overflowY: savedData?.length > 2 ? "auto" : "unset",
          position: "relative",
        }}
      >
        {savedData &&
          savedData.length > 0 &&
          savedData?.map((card) => (
            <ListGroup.Item
              key={card.id}
              className="d-flex justify-content-between align-items-center flex-column flex-md-row"
            >
              <div className="d-flex align-items-center gap-3">
                <img
                  src={
                    brandLogos[card.brand?.toLowerCase()] || brandLogos.default
                  }
                  alt={card.brand}
                  height="32"
                />
                <h5 className="m-0">
                  {capitalizeFirst(card.brand)} •••• {card.last4}
                </h5>
                {card.is_default && (
                  <Badge bg="primary" className="ms-1">
                    Default
                  </Badge>
                )}
              </div>

              <div className="position-relative" ref={menuRef}>
                <span style={{ fontSize: "14px" }}>
                  Expires {getMonthName(card.exp_month) + " " + card?.exp_year}
                </span>
                <Button
                  id="toggle_drop"
                  style={{
                    margin: "0px",
                    border: "none",
                    background: "none",
                    fontSize: "23px",
                    marginBottom: "10px",
                  }}
                  variant="light"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenMenuId((prev) =>
                      prev === card.id ? null : card.id
                    );
                  }}
                >
                  ...
                </Button>

                {openMenuId === card.id && (
                  <div
                    className="card-options-menu bg-white border rounded shadow-sm position-absolute"
                    style={{
                      top: "45px",
                      right: "14px",
                      zIndex: 1000,
                      minWidth: "150px",
                    }}
                  >
                    <ul className="list-unstyled m-0">
                      <li
                        className={`option-item px-3 border py-2 w-100 text-start 
                          ${
                            card.is_default
                              ? "text-muted not-allowed"
                              : "clickable"
                          }
                        `}
                        onClick={() => {
                          if (card.is_default === false) {
                            set_default_payment_method(card.id);
                            setOpenMenuId(null);
                          }
                        }}
                      >
                        {card.is_default ? "Default" : "Set as Default"}
                      </li>
                      <li
                        className="option-item border px-3 py-2 w-100 text-start clickable"
                        onClick={() => {
                          handleCard("delete", card);
                          setOpenMenuId(null);
                        }}
                      >
                        Delete
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </ListGroup.Item>
          ))}
      </ListGroup>
    </div>
  );
};

export default SavedCards;
